/* eslint-disable @typescript-eslint/no-unused-vars */

import { Box, Button } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useState } from "react"
import { ContentContainer } from "./components/styles"
import BankSelection from "../BankSelection"
import { BankRole, BankScenario, IBankMeta } from "../../api/interface"
import { PaymentInfoBlock } from "../../components/PaymentInfoBlock"
import BankIcon from "../../components/BankIcon"
import { ROUTES_PATHS } from "../../utils/constants"
import { RootState } from "../../store/store"
import { setSelectedBank } from "../../store/slices/payment"
import { usePaymentCheck } from "../../api/hooks/usePaymentCheck"
import ErrorModal from "../../components/Modal/ErrorModal"

export const Payments = () => {
  const { amount, selectedBank } = useSelector((state: RootState) => state.payment)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [errorText, setErrorText] = useState('')

  const { refetch } = usePaymentCheck(amount ?? 0)

  const handleSelectBank = (bank:  IBankMeta | null) => {
    dispatch(setSelectedBank(bank))
  }

  const handleContinue = async () => {
    const result = await refetch()
    
    if (result.isSuccess) {
      navigate(`/${ROUTES_PATHS.topUpMbankAccountPayments}/confirmation`)
    }

    if (result.error) {
      setErrorText(result.error.message)
      setOpen(true)
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Box sx={ContentContainer}>
      <Box
        display="flex"
        justifyContent={selectedBank ? "flex-start" : "center"}
        flexDirection="column"
        alignItems="center"
        height="100%"
        pb="40px"
        gap={4}
        sx={{
          "& > div": {
            width: "100%",
            overflow: "scroll",
            maxHeight: "calc(100vh - 235px)",
          },
        }}
      >
        {selectedBank ? (
          <PaymentInfoBlock
            title="Банк списания"
            margin="0"
            description={{
              main: selectedBank.title,
              secondary: "Система быстрых платежей",
            }}
            icons={<BankIcon logoUrl={selectedBank.logoUrl} size={50} />}
            onClick={() => handleSelectBank(null)}
          />
        ) : (
          <BankSelection
            isLoading={false}
            handleBankClick={(x) => handleSelectBank(x)}
            role={BankRole.RECEIVER}
            scenario={BankScenario.C2C_PUSH}
            disableViewFullList
            disableToken
          />
        )}
      </Box>

      <Box mt="auto" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Button
          variant="contained"
          disabled={!selectedBank}
          onClick={handleContinue}
        >
          Продолжить
        </Button>
      </Box>

      <ErrorModal open={open} onClose={handleClose} errorText={errorText} />
    </Box>
  )
}
